export default {
  edit: 'Edit',
  environment: 'Environment',
  executions: 'Executions',
  expanded: 'Expanded',
  export: 'Export'
}
